"use client";

import { cn } from "@jesus-central-church/shared";
import { motion } from "motion/react";
import { Calendar } from "lucide-react";
import { Button } from "../button";

export interface EventsEmptyStateProperties {
  onReset?: () => void;
  className?: string;
}

export function EventsEmptyState({
  onReset,
  className,
}: EventsEmptyStateProperties) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={cn("py-20 text-center", className)}
    >
      <div className="bg-freedom/5 mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full">
        <Calendar className="h-10 w-10 text-freedom/30" />
      </div>
      <h3 className="mb-2 font-bold text-2xl text-freedom">
        Geen events gevonden
      </h3>
      <p className="mb-6 text-freedom/60">
        Probeer een andere maand of pas je filters aan.
      </p>
      {onReset && (
        <Button onClick={onReset} colorScheme="strategy-gold" variant="outline">
          Wis filters
        </Button>
      )}
    </motion.div>
  );
}
